import { FormBlock } from '.';

export default class BlockChangeHistoryModel {
    blocksState: FormBlock[];
}
